// extracted by mini-css-extract-plugin
export var circle = "_3f-2";
export var icon = "_3f-a";
export var iconHighlight = "_3f-0";
export var lg = "_3f-8";
export var md = "_3f-7";
export var outline = "_3f-4";
export var sm = "_3f-6";
export var square = "_3f-1";
export var xl = "_3f-9";
export var xs = "_3f-5";
export var xxs = "_3f-3";